import React, { useContext, useEffect, useRef, useState } from "react";
import { Loading, useGetIdentity, useRedirect, UserIdentity } from "react-admin";
import Box from "@mui/material/Box";
import NotificationMessage, {
  notificationType,
} from "../components/NotificationMessage/NotificationMessage";
import { useParams } from "react-router";
import { APIContext } from "../store/APIStore";
import apiCalls from "../Configs/config";
import { routePaths } from "./SidebarMenu";
import logo from "../static/logo-new.png";
import { EmptyScreen } from "../components/EmptyScreen/EmptyScreen";
import { theme } from "../theme";
import { RiErrorWarningLine } from "react-icons/ri";
import posthog from "posthog-js";
import { useLocation } from "react-router-dom";

const AnalyticsDashboardPublic = () => {
  const [dashboardEmbedUrl, setDashboardEmbedUrl] = useState<string>("");
  const [eventId, setEventId] = useState<string>("");
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const notificationRef = useRef<any>();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { dashboardPublicToken } = useParams() as any;
  const api = useContext(APIContext);
  const redirect = useRedirect();
  let location = useLocation();
  const { identity } = useGetIdentity();


  useEffect(() => {
    // fetch the selected event if it wasn't set in the store
    if (dashboardPublicToken) {
      fetchDashboardIframeEmbedUrl(dashboardPublicToken);
    }
  }, [dashboardPublicToken]);

  useEffect(() => {
    if (!posthog || !dashboardEmbedUrl) return;
    posthog.capture("$pageview", {
      path: location.pathname,
      search: location.search,
      eventId: `${eventId}`,
    });
  }, [dashboardEmbedUrl]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 12000);
    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {
    if (!loading && dashboardEmbedUrl) {
      setUserIdentity();
    }
  }, [loading, dashboardEmbedUrl]);

  const setUserIdentity = async () => {
    if (!identity?.id) {
      posthog.people.set({
        name: dashboardPublicToken,
        is_internal: false,
      });
      return
    }
    const userId = identity?.id as number;
    try {
      const user: any = await api.userService?.getUser(userId);
      posthog.identify(user.id);
      posthog.people.set({
        name: user.fullName,
        email: user.email,
        is_internal: user.email
          ?.toLowerCase()
          .endsWith("@fielddrive.com"),
      });
    } catch (error: any) {
      console.log(error);
      posthog.people.set({
        name: dashboardPublicToken,
        is_internal: false,
      });
    }
  };

  const fetchDashboardIframeEmbedUrl = async (dashboardPublicToken: string) => {
    try {
      const data = await api.analyticsSettingsService.fetchIframeUrl(
        dashboardPublicToken
      );
      setEventId(data.eventId as string);
      setDashboardEmbedUrl(data.dashboardEmbedUrl as string);
    } catch (error: any) {
      notificationRef.current?.show(
        error?.response?.data?.message,
        notificationType.Error
      );
      setLoading(false);
      setError(true);
    }
  };

  return (
    <>
      <Box sx={{ height: "100vh" }}>
        {loading && <Loading className="" />}
        {!loading && (
          <>
            <Box
              onClick={() => redirect(`https://fielddrive.com`)}
              sx={{
                height: "60px",
                position: "fixed",
                backgroundImage: `url(${logo})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "left",
                backgroundSize: "160px",
                marginLeft: "30px",
                backgroundColor: "white",
                width: "100%",
                cursor: "pointer",
              }}
            ></Box>
            {error && (
              <EmptyScreen
                message="This link is invalid or has expired. Please contact support for assistance."
                icon={
                  <RiErrorWarningLine
                    size="60px"
                    color={theme.palette.primary.main}
                  />
                }
              />
            )}
            {dashboardEmbedUrl && (
              <Box sx={{ height: "100%", paddingTop: "60px" }}>
                <iframe
                  ref={iframeRef}
                  src={dashboardEmbedUrl}
                  width="100%"
                  style={{ border: 0 }}
                  height="100%"
                  allowTransparency
                  onLoad={() => setLoading(false)}
                />
              </Box>
            )}
          </>
        )}
      </Box>
      <NotificationMessage ref={notificationRef} />
    </>
  );
};

export default AnalyticsDashboardPublic;
